import { render, staticRenderFns } from "./InputFile.global.vue?vue&type=template&id=3cd1760a&scoped=true&lang=pug&"
import script from "./InputFile.global.vue?vue&type=script&lang=ts&"
export * from "./InputFile.global.vue?vue&type=script&lang=ts&"
import style0 from "./InputFile.global.vue?vue&type=style&index=0&id=3cd1760a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1760a",
  null
  
)

export default component.exports